import React, { Component } from 'react';
import isNil from 'lodash/isNil';

import Menu from '../../../components/elements/menu/Menu';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import { ReactComponent as DetailsIcon } from 'new/components/icons/fi-rr-info.svg';

class SchemaSpecDetailActions extends Component {
  render() {
    const { readOnly, isManaged, disableEditing, disableEditMessage, data, hideMenuDetails } =
      this.props;
    const isInUse = has(data, 'data_sets') && !isEmpty(data.data_sets);

    let menuItems = [];
    if (!hideMenuDetails) {
      menuItems.push({
        label: 'Details',
        icon: <DetailsIcon />,
        onClick: this._handleOpenDetails,
      });
    }
    let editMenuItem = {
      label: 'Edit',
      icon: (
        <i
          className="fa fa-pencil"
          style={{
            color: '#6D7E8F',
            fontSize: 19,
          }}
          aria-hidden="true"
        />
      ),
      onClick: this._handleEditClicked,
    };

    if (!isNil(disableEditing) && disableEditMessage && disableEditing) {
      editMenuItem.disable = true;
      editMenuItem.disableMessage = disableEditMessage;
    } else if (isManaged === true) {
      editMenuItem.disable = true;
      editMenuItem.disableMessage =
        'This transform is managed by Nexla. Please contact support@nexla.com for editing this transform.';
    }
    menuItems.push(editMenuItem);

    let deleteMenuItem = {
      type: 'dialog',
      label: 'Delete',
      icon: (
        <i
          className="fa fa-trash"
          style={{
            color: '#6D7E8F',
            fontSize: 19,
          }}
          aria-hidden="true"
        />
      ),
      dialogMessage: `Please confirm you want to delete transform ${data.name}(ID: ${data.id})`,
      primaryButtonColor: 'error',
      discardLabel: 'Cancel',
      confirmLabel: 'Delete',
      onClick: this._handleDeleteClicked,
    };

    if (isInUse) {
      deleteMenuItem.disable = true;
      deleteMenuItem.disableMessage =
        'This template cannot be deleted as it is being used in a Nexset';
    }

    menuItems.push(deleteMenuItem);

    return <div className="detail-actions">{!readOnly && <Menu items={menuItems} />}</div>;
  }

  _handleEditClicked = (event) => {
    this.props.onEditButtonClicked(this.props.data);
  };

  _handleDeleteClicked = (event) => {
    this.props.deleteSchemaSpec(this.props.data.id);
  };

  _handleOpenDetails = (e) => {
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    const { data, onOpenDetailsMenu, openDetailDrawerInPortal, openDetailsModal } = this.props;
    if (typeof onOpenDetailsMenu === 'function') {
      onOpenDetailsMenu(data);
      return;
    }
    if (typeof openDetailsModal === 'function') {
      openDetailsModal(data);
      return;
    }
    if (typeof openDetailDrawerInPortal === 'function') {
      openDetailDrawerInPortal(data, {});
    }
  };
}

SchemaSpecDetailActions.defaultProps = {
  hideMenuDetails: false,
};

export default SchemaSpecDetailActions;
